import React, { Component } from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';

import { connect } from 'react-redux';

import { withRouter } from '../router/withRouter';
import { reduxForm } from 'redux-form';

import { cloneDeep } from 'lodash';
import {
    clearRetailerQueryData,
    getAllOrderableGameItems,
    getRetailerSelectData,
    initGameList,
    initRetailerSelect,
    updateSelectedRetailersValues,
} from '../../redux/actions';

export class GameReviewHeader extends Component {
    constructor() {
        super();
        this.state = {
            searchModel: cloneDeep(this.initSearchModel),
            selectedRetailer: null,
            retailerOptionsContent: [],
        };
    }

    initSearchModel = {
        page: 0,
        size: 10,
        sortOrder: 'ASC',
        sortColumn: 'reference',
        sortColumns: [],
        filters: { status: ['ACTIV'] },
        query: '',
    };

    componentDidMount() {
        this.initData();
    }

    initData = async () => {
        const { getRetailers , clearRetailerQueryData} = this.props;
        await clearRetailerQueryData();
        await getRetailers(this.initSearchModel);
        this.setState({ selectedRetailer: null });
    };

    onChange = (data, val, a) => {
        const {
            retailerSelect: { content },
            getAllOrderableGameItems,
            updateSelectedRetailersValues,
        } = this.props;
        const retailerId = val.value;
        const retailer = content.find((retailer) => retailer.id === retailerId);
        const jurisdiction = retailer?.jurisdiction?.code;
        const retailerType = retailer?.type?.reference;
        getAllOrderableGameItems(retailerType, jurisdiction);

        this.setState({ selectedRetailer: val.value });
        updateSelectedRetailersValues(retailer);
    };

    onScrollToLast = async event => {
        const { target } = event;

        const {
            retailerSelect: { page },
            getRetailers,
        } = this.props;
        const { searchModel } = this.state;
        searchModel.query = '';


        if (
            target.scrollHeight > target.offsetHeight &&
            target.scrollHeight - target.offsetHeight - target.scrollTop < 1
        ) {

            if (searchModel.page == page.number) {
                searchModel.page = page.number + 1;
                await getRetailers(searchModel);
            }

        }
    };

    onOpen = () => {

        setTimeout(() => {
            const menu = document.querySelector('.visible.menu');
            if (menu) {
                menu.addEventListener('scroll', this.onScrollToLast);
            }
        }, 0);
    };


    onSearch = async (options, query) => {
        const { getRetailers, clearRetailerQueryData } = this.props;
        await clearRetailerQueryData();
        const searchModel = cloneDeep(this.initSearchModel);
        searchModel.query = query.searchQuery;
        await this.setState({ searchModel });
        await getRetailers(searchModel);
    };

    onClear = async () => {
        const { initGameList } = this.props;
        initGameList();
        this.initData();
    };

    render() {
        const {
            retailerSelect: { content, loading },
        } = this.props;

        const retailerOptions = content?.map((retailer) => ({
            text: retailer.reference + ' - ' + retailer.name,
            value: retailer.id,
            key: retailer.id,
        }));
        return (
            <div>
                <div className="retailer-info-header-container">
                    <div className="subheader-text">{'Retailer:'}</div>
                    <Dropdown
                        className="async-dropdown"
                        options={retailerOptions}
                        loading={loading}
                        search={(options) => options}
                        clearable={true}
                        onScroll={this.onScrollToLast}
                        onOpen={this.onOpen}
                        onSearchChange={this.onSearch}
                        onChange={(data, val) => this.onChange(data, val)}
                        value={this.state.selectedRetailer}
                    />
                    <Icon
                        className="icon-Close"
                        color={'black'}
                        onClick={this.onClear}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ retailerSelect: { content, page } }) => ({
    retailerSelect: { content, page },
});
const mapDispatchToProps = (dispatch) => {
    return {
        getRetailers: (searchModel) =>
            dispatch(getRetailerSelectData(searchModel)),
        init: () => dispatch(initRetailerSelect()),
        getAllOrderableGameItems: (retailerType, jurisdiction) =>
            dispatch(getAllOrderableGameItems(retailerType, jurisdiction)),
        clearRetailerQueryData: () => dispatch(clearRetailerQueryData()),
        initGameList: () => dispatch(initGameList()),
        updateSelectedRetailersValues: (selectedValues) =>
            dispatch(updateSelectedRetailersValues(selectedValues)),
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(
        reduxForm({
            form: 'GameReviewHeader',
            enableReinitialize: true,
        })(GameReviewHeader),
    ),
);

